import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DetailsComponent } from './pages/details/details.component';
import { NaoEncontradoComponent } from './pages/nao-encontrado/nao-encontrado.component';
import { ProcessingComponent } from './pages/processing/processing.component';
import { SearchComponent } from './pages/search/search.component';
import { VersionComponent } from './pages/version/version.component';

const routes: Routes = [
  { path: '', component: SearchComponent },
  { path: 'detalhes', component: DetailsComponent, data: { isSair: true } },
  { path: 'detalhes-internos', component: DetailsComponent, data: { isSair: false } },
  { path: 'processando', component: ProcessingComponent },
  { path: 'nao-encontrado', component: NaoEncontradoComponent },
  { path: 'version-proj', component: VersionComponent },
  { path: '**', component: SearchComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
